import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Space,
  message,
} from "antd";
import "./styles/supercodes.css";
import { CloseOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import config from "../../../config";
import dayjs from "dayjs";
const base_url = config.base_url;
const EditSuperCodeModal = ({
  open,
  closeModal,
  editedCoupon,
  formateSuperCodeTableData,
  setTableData,
}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const feedbackMessage = (type, message) => {
    messageApi.open({
      type: type,
      content: message,
    });
  };

  const [form] = Form.useForm();
  const [couponExpirationDate, setCouponExpirationDate] = useState(
    editedCoupon?.expiration_date ? 2 : 1
  );
  let has_subscription_end_value = false;
  if (editedCoupon?.subscription_end) {
    has_subscription_end_value = true;
  }
  const [copounSubscriptionEnd, setcopounSubscriptionEnd] = useState(
    has_subscription_end_value ? 2 : editedCoupon?.expiration_date ? 2 : 1
  );
  const [editButtonLoading, setEditButtonLoading] = useState(false);
  const [deleteButtonLoading, setDeleteButtonLoading] = useState(false);
  useEffect(() => {
    if (!editedCoupon) return;
    console.log(editedCoupon);

    form.setFieldsValue({
      created_for: editedCoupon.created_for,
      coupon_expiration_date: editedCoupon.expiration_date ? 2 : 1,
      coupon_status: editedCoupon.status,
    });

    if (editedCoupon.expiration_date) {
      form.setFieldsValue({
        expiration_date_for_copoun: dayjs(editedCoupon.expiration_date),
      });
      setCouponExpirationDate(editedCoupon?.expiration_date ? 2 : 1);
    }

    if (editedCoupon.isTimeReward) {
      form.setFieldsValue({
        subscription_end_date_for_copoun: dayjs(editedCoupon.subscription_end),
        subscription_end: editedCoupon.subscription_end ? 2 : 1,
      });
      setcopounSubscriptionEnd(editedCoupon?.subscription_end ? 2 : 1);
    }
  }, [editedCoupon]);

  const handleEditCoupon = async (values) => {
    setEditButtonLoading(true);
    let expiration_date;
    let bodyString = `code_family=${editedCoupon.coupon_family}&created_for=${values.created_for}&status=${values.coupon_status}`;

    if (values.coupon_expiration_date === 2 && !editedCoupon.isTimeReward) {
      expiration_date = dayjs(values.expiration_date_for_copoun).valueOf();
    }
    if (expiration_date && !editedCoupon.isTimeReward) {
      bodyString = bodyString + `&expiration_date=${expiration_date}`;
    }

    if (values.subscription_end === 2 && editedCoupon.isTimeReward) {
      expiration_date = dayjs(
        values.subscription_end_date_for_copoun
      ).valueOf();
    }
    if (expiration_date && editedCoupon.isTimeReward) {
      bodyString =
        bodyString + `&subscription_end=${expiration_date}&lifetime=${false}`;
    }
    if (!expiration_date && editedCoupon.isTimeReward) {
      bodyString = bodyString + `&lifetime=${true}`;
    }

    await fetch(base_url + "admin/supercodes/edit", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: bodyString,
    })
      .then((res) => res.json())
      .then((res) => {
        setEditButtonLoading(false);
        setTableData(formateSuperCodeTableData(res));
        feedbackMessage("success", "Code Edited Successfully");
        setcopounSubscriptionEnd(1);
        setCouponExpirationDate(1);
      })
      .catch((err) => {
        console.log(err);
        setcopounSubscriptionEnd(1);
        setCouponExpirationDate(1);
        setEditButtonLoading(false);
        feedbackMessage("error", "Error in editing the code");
      });
    closeModal();
  };

  const handleDeleteCoupon = async () => {
    setDeleteButtonLoading(true);

    await fetch(base_url + "admin/supercodes/delete", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `code=${editedCoupon.coupon_family}`,
    })
      .then((res) => res.json())
      .then((res) => {
        feedbackMessage("success", "Code Deleted Successfully");
        setTableData(formateSuperCodeTableData(res));
        setDeleteButtonLoading(false);
      })
      .catch((err) => {
        console.log(err);
        feedbackMessage("error", "Error in deleting the code");
        setDeleteButtonLoading(false);
      });
    closeModal();
  };
  return (
    <>
      {contextHolder}
      <Modal
        className="superCodesModal"
        open={open}
        onCancel={() => {
          form.resetFields();
          setcopounSubscriptionEnd(1);
          setCouponExpirationDate(1);
          closeModal();
        }}
        onOk={() => {
          form.resetFields();
          setcopounSubscriptionEnd(1);
          setCouponExpirationDate(1);
          closeModal();
        }}
        closeIcon={null}
        footer={[
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              height: "41px",
              position: "relative",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "15px",
              }}
            >
              <Button
                onClick={(e) => {
                  handleDeleteCoupon();
                }}
                className="footerDelete"
                key="delete"
                style={{
                  backgroundColor: "rgba(178, 6, 6, 1)",
                  width: "max-content",
                  height: "40px",
                }}
                disabled={editButtonLoading}
                loading={deleteButtonLoading}
              >
                Delete
              </Button>
            </div>
            <div
              style={{
                display: "flex",
                gap: "15px",
              }}
            >
              <Button
                style={{
                  width: "80px",
                  height: "40px",
                }}
                key="cancel"
                onClick={(e) => {
                  closeModal();
                }}
                disabled={editButtonLoading || deleteButtonLoading}
              >
                Cancel
              </Button>
              <Button
                onClick={(e) => {
                  form.submit();
                }}
                htmlType="submit"
                className="footerButtonSave"
                key="save"
                style={{
                  width: "80px",
                  height: "40px",
                }}
                loading={editButtonLoading}
                disabled={deleteButtonLoading}
              >
                save
              </Button>
            </div>
          </div>,
        ]}
      >
        <div className="superCodesModalContent">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="superCodesModalTitle">Edit code name</p>
            <CloseOutlined
              onClick={() => {
                closeModal();
              }}
              style={{
                marginTop: "5px",
                position: "absolute",
                right: "24px",
                cursor: "pointer",
              }}
            />
          </div>
          <Form form={form} onFinish={handleEditCoupon}>
            <Form.Item
              style={{
                width: "265px",
              }}
              className="formLabel formLabelSuperCodes"
              labelCol={{ span: 24 }}
              name={"created_for"}
              label="Created for"
              required
              rules={[
                {
                  required: true,
                  message: "Created for cannot be empty ",
                },
              ]}
            >
              <Input className="formInput" />
            </Form.Item>{" "}
            <Form.Item
              style={{
                width: "380px",
              }}
              className="formLabel formLabelSuperCodes"
              labelCol={{ span: 24 }}
              name={"coupon_status"}
              label="Coupon Status"
              required
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                style={{
                  width: "113px",
                  height: "41px",
                  textAlign: "left",
                  display: "flex",
                }}
              >
                <Select.Option value="active">Active</Select.Option>
                <Select.Option value="inactive">Inactive</Select.Option>
              </Select>
            </Form.Item>
            {!editedCoupon?.isTimeReward && (
              <Form.Item
                style={{
                  width: "190px",
                }}
                className="formLabel formLabelSuperCodes"
                labelCol={{ span: 24 }}
                name={"coupon_expiration_date"}
                label="Coupon expiration date"
                required
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Radio.Group
                  onChange={(e) => {
                    setCouponExpirationDate(e.target.value);
                    e.target.value === 1 &&
                      form.setFieldsValue({
                        expiration_date_for_copoun: undefined,
                      });
                    e.target.value === 2 &&
                      form.setFieldsValue({
                        expiration_date_for_copoun: dayjs().add(2, "month"),
                      });
                  }}
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                  value={couponExpirationDate}
                >
                  <Space
                    direction="vertical"
                    style={{
                      marginLeft: "25px",
                    }}
                  >
                    <Radio
                      style={{
                        width: "200px",
                      }}
                      value={1}
                    >
                      {editedCoupon?.customer_reward_time
                        ? "Unlimited"
                        : "No expiration date"}
                    </Radio>
                    <Radio
                      style={{
                        width: "200px",
                      }}
                      value={2}
                    >
                      {editedCoupon?.customer_reward_time
                        ? "Set a specific date"
                        : "Set expiration date:"}
                    </Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
            )}
            {editedCoupon?.isTimeReward && (
              <Form.Item
                style={{
                  width: "220px",
                }}
                className="formLabel formLabelSuperCodes"
                labelCol={{ span: 24 }}
                name={"subscription_end"}
                label="free subscription will end at"
                required
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Radio.Group
                  onChange={(e) => {
                    setcopounSubscriptionEnd(e.target.value);
                    e.target.value === 1 &&
                      form.setFieldsValue({
                        subscription_end_date_for_copoun: undefined,
                      });
                    e.target.value === 2 &&
                      form.setFieldsValue({
                        subscription_end_date_for_copoun: dayjs().add(
                          2,
                          "month"
                        ),
                      });
                  }}
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                  value={copounSubscriptionEnd}
                >
                  <Space
                    direction="vertical"
                    style={{
                      marginLeft: "25px",
                    }}
                  >
                    <Radio
                      style={{
                        width: "200px",
                      }}
                      value={1}
                    >
                      Unlimited
                    </Radio>
                    <Radio
                      style={{
                        width: "200px",
                      }}
                      value={2}
                    >
                      specific date
                    </Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
            )}
            {!editedCoupon?.isTimeReward &&
              (couponExpirationDate === 2 ? (
                <Form.Item
                  style={{
                    transform: "translate(160px,-35px)",
                    width: "206px",
                    height: "46px",
                    marginLeft: "25px",
                  }}
                  // className="formLabel formLabelSuperCodes"
                  // labelCol={{ span: 24 }}
                  // name={"coupon_expiration_date"}
                  // label="Coupon expiration date"
                  name={"expiration_date_for_copoun"}
                >
                  <DatePicker
                    allowClear={false}
                    onChange={(date, dateString) => {}}
                    style={{
                      // transform: "translate(-50px,55px)",
                      width: "206px",
                      height: "46px",
                    }}
                    format="YYYY-MM-DD"
                    placeholder="YYYY-MM-DD"
                    disabledDate={(current) => {
                      let customDate = dayjs().format("YYYY-MM-DD");
                      return (
                        current && current < dayjs(customDate, "YYYY-MM-DD")
                      );
                    }}
                    defaultValue={dayjs().add(2, "month")}
                  />
                </Form.Item>
              ) : (
                <div
                  style={{
                    transform: "translateY(55px)",
                    width: "25%",
                    height: "46px",
                  }}
                ></div>
              ))}
            {editedCoupon?.isTimeReward &&
              (copounSubscriptionEnd === 2 ? (
                <Form.Item
                  style={{
                    transform: "translate(160px,-35px)",
                    width: "206px",
                    height: "46px",
                    marginLeft: "25px",
                  }}
                  // className="formLabel formLabelSuperCodes"
                  // labelCol={{ span: 24 }}
                  // name={"coupon_expiration_date"}
                  // label="Coupon expiration date"
                  name={"subscription_end_date_for_copoun"}
                >
                  <DatePicker
                    allowClear={false}
                    onChange={(date, dateString) => {}}
                    style={{
                      // transform: "translate(-50px,55px)",
                      width: "206px",
                      height: "46px",
                    }}
                    format="YYYY-MM-DD"
                    placeholder="YYYY-MM-DD"
                    disabledDate={(current) => {
                      let customDate = dayjs().format("YYYY-MM-DD");
                      return (
                        current && current < dayjs(customDate, "YYYY-MM-DD")
                      );
                    }}
                    defaultValue={dayjs().add(2, "month")}
                  />
                </Form.Item>
              ) : (
                <div
                  style={{
                    transform: "translateY(55px)",
                    width: "25%",
                    height: "46px",
                  }}
                ></div>
              ))}
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default EditSuperCodeModal;
